import { render } from "./TableEmptyState.vue?vue&type=template&id=24d1c521&scoped=true"
import script from "./TableEmptyState.vue?vue&type=script&lang=js"
export * from "./TableEmptyState.vue?vue&type=script&lang=js"

import "./TableEmptyState.vue?vue&type=style&index=0&id=24d1c521&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d1c521"]])

export default __exports__